import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Knows the app's own spacing tokens, so a later px-0 replaces px-gutter.
const twMerge = extendTailwindMerge({
  extend: {
    theme: { spacing: ["gutter"] },
    classGroups: {
      // Font roles are sizes, so foreground colors must coexist with them.
      "font-size": [{ text: [
        (value: string) => value.startsWith("ui-") || value.startsWith("display-"),
        "display", "h1", "h2", "h3", "h4", "h5", "h6",
        "text-large", "text-main", "text-small",
      ] }],
      "font-weight": ["font-ui", "font-regular", "font-semi-bold"],
      leading: [{ leading: ["display", "caption", "copy", "reading", "status", "control"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Determines the aspect ratio for media content in the drawer (always 9:16)
 * @param messageType - The type of message (e.g., 'ig_reel', 'video', 'image')
 * @returns The aspect ratio as a number (9/16 for all types in drawer)
 */
export function getMediaAspectRatio(messageType?: string): number {
  // All media types in the drawer should be 9:16 for consistency
  return 9 / 16;
}

/**
 * Gets the natural aspect ratio for media content (for full-screen view)
 * @param messageType - The type of message (e.g., 'ig_reel', 'video', 'image')
 * @returns The natural aspect ratio as a number
 */
export function getNaturalMediaAspectRatio(messageType?: string): number {
  switch (messageType) {
    case "ig_reel":
      return 9 / 16; // 9:16 aspect ratio for Instagram reels (portrait)
    case "video":
      return 16 / 9; // 16:9 aspect ratio for regular videos (landscape)
    default:
      return 4 / 3; // 4:3 aspect ratio for images (default)
  }
}
